import { signal, Injectable } from '@angular/core';

import { Profile } from '@/app/entities/profile';

import { AuthStatus } from './types';

@Injectable({
  providedIn: 'root',
})
export class AuthStore {
  private readonly authUser = signal<Profile | null>(null);
  private readonly authStatus = signal<AuthStatus>('unknown');

  readonly user = this.authUser.asReadonly();
  readonly status = this.authStatus.asReadonly();

  setGuest(): void {
    this.authUser.set(null);
    this.authStatus.set('guest');
  }

  setAuthUser(user: Profile | null): void {
    this.authUser.set(user);
    this.authStatus.set('authed');
  }

  reset(): void {
    this.authUser.set(null);
    this.authStatus.set('unknown');
  }
}
